import React from 'react'
import PropTypes from 'prop-types'
import withLayout from '../../../layout/withLayout'
import { lifecycle } from 'recompose'
import EmailTemplateVariantSelection from './EmailTemplateVariantSelection'
import EmailTemplateVariantList from './EmailTemplateVariantList'
import EmailMacro from './EmailMacro'

const ManageEmailTemplates = (props) => {
    return (
        <div>
            <EmailTemplateVariantSelection {...props}/>
            <EmailTemplateVariantList {...props}/>
            <EmailMacro {...props}/>
        </div>
    )
}


ManageEmailTemplates.propTypes = {
    userSelection: PropTypes.object.isRequired,
    processList: PropTypes.array.isRequired,
    templateList: PropTypes.array.isRequired,
    emailTemplateVariantList: PropTypes.array.isRequired,
    isEmailAdmin: PropTypes.bool.isRequired,
    processMacroList: PropTypes.array,

    findEmailTemplateList: PropTypes.func.isRequired,
    changeProcess: PropTypes.func.isRequired,
    findEmailTemplateById: PropTypes.func.isRequired,
    changeLocale: PropTypes.func.isRequired,
    saveEmailTemplateVariant: PropTypes.func.isRequired,
    createEmailTemplateVariant: PropTypes.func.isRequired,
    testEmailTemplateVariant: PropTypes.func.isRequired,
    deleteEmailTemplateVariant: PropTypes.func.isRequired,
    getProcessMacroList: PropTypes.func.isRequired,
}


export default lifecycle({
    componentDidMount () {
        this.props.findEmailTemplateList()
    },
})(withLayout(ManageEmailTemplates))





// WEBPACK FOOTER //
// ./src/modules/email/component/manage/ManageEmailTemplate.js